var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C10.29858 0 0 10.07233 0 22.5S10.29858 45 23 45s23-10.07233 23-22.5S35.70142 0 23 0zm1.57177 15.65004c-.40544 0-.85646.51777-.85646 1.2128v2.4046H28v3.43314h-4.28469V33h-4.04718V22.70058H16v-3.43314h3.66813V17.25c0-2.89438 2.06558-5.25 4.90364-5.25H28v3.65004h-3.42823z",
    fill: "#FFF",
    fillRule: "nonzero",
    fillOpacity: 0.7
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/media/facebook.svg";
export { SvgFacebook as ReactComponent };